import { useState } from 'react';
import { createPopup, Popup } from '@typeform/embed';
import { TypeformResponse } from '~/api/typeform';
import delay from '~/utils/delay';
import Cookies from 'js-cookie';
import { KnownCookie } from 'common-types';
import { fireClickedExpertQuiz } from '~/services/analytics/events/gearExperts';
import { AnalyticsSource } from '~/services/analytics/AnalyticsInterfaces';
import { FT_GEAR_EXPERT_CTA_MODE } from '../constants/featureToggles';

const FORM_ID = 'YQmH0uwo';

const sportQuestionId = '1a7e8ba2-58d8-44b6-94d5-8e479a3f9633';
const nameQuestionId = '2127a2d2-4976-4ed1-9fda-79dfc12797ab';
const emailQuestionId = '2aee5b8e-aa9b-44db-9f52-a5f91e447938';
const phoneQuestionId = '9962c01b-aef8-4bc8-8e7a-36718b05de1b';

const fetchTypeformResponse = async (
  responseId: string,
  attempt = 1,
): Promise<TypeformResponse | null> => {
  if (attempt > 3) {
    return null;
  }

  const response = await fetch(
    `${window.location.origin}/web_bff/v1/typeform/forms/${FORM_ID}/responses/${responseId}`,
    {
      method: 'get',
    },
  );

  const data = (await response.json()) as TypeformResponse;

  if (data.items.length === 0) {
    await delay(500);

    return fetchTypeformResponse(responseId, attempt + 1);
  }

  return data;
};

interface GearExpertPopupOptions {
  onSubmit?: () => void;
}

export default function useGearExpertPopup(
  options: GearExpertPopupOptions = {},
) {
  const [submitted, setSubmitted] = useState<boolean>(false);

  let popup: Popup | { open: () => void };

  if (FT_GEAR_EXPERT_CTA_MODE === 'zendesk') {
    popup = {
      open: () => {
        Cookies.set('gexp_init' as KnownCookie, '1');

        window.zE?.('webWidget', 'updateSettings', {
          webWidget: {
            chat: {
              suppress: false,
            },
            contactForm: {
              suppress: false,
            },
            helpCenter: {
              suppress: false,
            },
            talk: {
              suppress: false,
            },
            answerBot: {
              suppress: false,
            },
          },
        });
        window.zE?.('webWidget', 'open');
        setSubmitted(true);
      },
    };
  } else {
    popup = createPopup(FORM_ID, {
      onSubmit: async payload => {
        const typeformResponse = await fetchTypeformResponse(
          payload.responseId,
        );

        options?.onSubmit?.();

        if (typeformResponse) {
          Cookies.set('typeform_submitted' as KnownCookie, '1');
        }

        setSubmitted(true);
      },
    });
  }

  function open(src?: AnalyticsSource) {
    popup.open();
    fireClickedExpertQuiz(src);
  }

  return {
    open,
    submitted,
  };
}
